import actions from '../actions';
import modal from '../helpers/modal';

const {
  OPEN_MODAL,
  CLOSE_MODAL
} = actions;

/*
 * Reducers
 */

export function modalContent(state = null, action) {
  switch (action.type) {

  case OPEN_MODAL:
    modal.openModal();
    return action.content;

  case CLOSE_MODAL:
    modal.closeModal();
    return null;

  default:
    return state;
  }
}

export function hasOpenModal(state = false, action) {
  switch (action.type) {

  case OPEN_MODAL:
    return true;

  case CLOSE_MODAL:
    return false;

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modal.js